<template>
  <head>
    <title>
      {{ $t("update") + " " + $t("whyUs") }}
    </title>
  </head>
  <div class="update-service">
    <AdminSidebar>
      <form class="form bg-dark my-5" @submit.prevent="updateService()">
        <p class="title">
          {{ $t("update") + " " + $t("whyUs") }}
        </p>

        <div class="flex">
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="name_ar"
              v-model="data.name_ar"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("name_ar") }}</span
            >
          </label>
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="name_en"
              v-model="data.name_en"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("name_en") }}</span
            >
          </label>
        </div>

        <div class="flex">
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="title_ar"
              v-model="data.title_ar"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("title_ar") }}</span
            >
          </label>
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="title_en"
              v-model="data.title_en"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("title_en") }}</span
            >
          </label>
        </div>

        <div class="flex">
          <label class="w-49">
            <textarea
              placeholder=""
              class="input"
              name="description_ar"
              v-model="data.description_ar"
            ></textarea>
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
                top: '50px',
              }"
              >{{ $t("description_ar") }}</span
            >
          </label>
          <label class="w-49">
            <textarea
              placeholder=""
              class="input"
              name="description_en"
              v-model="data.description_en"
            ></textarea>
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
                top: '50px',
              }"
              >{{ $t("description_en") }}</span
            >
          </label>
        </div>

        <div
          class="Error"
          :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
          style="text-align: start"
          v-if="ErrorMessage"
        >
          {{ ErrorMessage }}
        </div>
        <button class="submit">
          {{ $t("update") }}
        </button>
      </form>
    </AdminSidebar>
  </div>
</template>

<script>
import axios from "axios";
import AdminSidebar from "@/components/AdminDashboard/AdminSidebar.vue";
import store from "@/store";

export default {
  name: "update-service",
  data() {
    return {
      data: {
        name_ar: "",
        name_en: "",
        description_ar: "",
        description_en: "",
        title_ar: "",
        title_en: "",
      },
      ErrorMessage: "",
    };
  },
  methods: {
    updateService() {
      store.state.loading_state = 1;
      this.ErrorMessage = "";
      for (let key in this.data) {
        if (this.data[key] === "") {
          this.ErrorMessage =
            this.$i18n.locale === "ar"
              ? "الرجاء تعبئة كل الحقول المطلوبة"
              : "Please fill all the required fields";
          store.state.loading_state = 0;
          return;
        }
      }

      const form = new FormData();

      for (const [key, value] of Object.entries(this.data)) {
        form.append(key, value);
      }

      form.append("WEBSITE_ID", 1);

      const token = window.sessionStorage.getItem("token");
      axios
        .post(store.state.server + "api/update_service/" + this.data.id, form, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.status == 200) {
            store.state.loading_state = 0;
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  components: {
    AdminSidebar,
  },
  mounted() {
    this.data = store.state.Data;
  },
};
</script>
